// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5ldI1","name":"Header_name__3u5Fe","birthday":"Header_birthday__2jU4W","skeleton":"Header_skeleton__f5wxx"};